<template>
  <div class="tw-px-4 tw-py-6">
    <section class="tw-flex tw-items-start tw-gap-2">
      <label class="ui-toggle" for="internal_chat_enable_notification_sound" size="sm">
        <input class="ui-toggle__input" type="checkbox" value="1" @change="$emit('enable-notification-sound')" :checked="enableNotificationSound" name="enableNotificationSound" id="internal_chat_enable_notification_sound">
        <div class="ui-toggle__toggle"></div>
      </label>
      <div>
        <label class="primary--label tw-text-sm tw-font-medium tw-leading-5" for="internal_chat_enable_notification_sound">
          Sons de notificação
        </label>
        <p class="tw-block tw-text-sm tw-leading-5">
          Quando você receber uma nova mensagem o chat emitirá um som de notificação
        </p>
      </div>
    </section>
    <hr class="tw-my-6 tw-border-ugray-200 tw-border">
    <section class="tw-flex tw-items-start tw-gap-2" @click="handleInternalChatClick" v-if="canManageEstablishment">
      <label class="ui-toggle" for="internal_chat_enabled" size="sm">
        <input class="ui-toggle__input" type="checkbox" value="1" @change="$emit('enable-notification-sound')" :checked="internalChatEnabled" name="enableNotificationSound" id="internal_chat_enabled">
        <div class="ui-toggle__toggle"></div>
      </label>
      <div>
        <label class="primary--label tw-text-sm tw-font-medium tw-leading-5" for="internal_chat_enabled">
          Chat da clínica
        </label>
        <p class="tw-block tw-text-sm tw-leading-5">
          Desativar para todos profissionais da clínica
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { alertModal } from "../../helpers/sweet_alert_html"
import axios from "axios";
axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-Token": document
    .querySelector("meta[name=csrf-token]")
    .getAttribute("content"),
};

export default {
  props: ["enableNotificationSound", "canManageEstablishment"],
  data: function () {
    return {
      internalChatEnabled: true
    };
  },
  methods: {
    handleInternalChatClick(event){
      event.preventDefault();
      swal({
        html: alertModal({
          title: "Desativar chat da clínica",
          text: "Tem certeza que deseja desativar o chat? <br> Pode ser ativo novamente nas configurações.",
          type: 'alert'
        }),
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Desativar',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'alert-button--confirm',
        cancelButtonClass: 'alert-button--cancel',
        confirmButtonColor: '#B54708',
        cancelButtonColor: '#fff',
      })
      .then((result) => {
        if (result.value) {
          this.disableInternalChat()
        }
      })
    },
    async disableInternalChat(){
      try {
        const response = await axios.put("/establishment/toggle_attribute", {
          attribute: "internal_chat_enable",
        });

        document.querySelector("#internal-chat").remove();
      } catch (error) {
        console.error(error);
        toastr.error("Não foi possível desativar o chat da clínica. Tente novamente ou entre em contato");
      }
    }
  }
};

</script>
